var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('h3',{staticClass:"title is-3 has-text-info"},[_vm._v(_vm._s(_vm.audit.standard.name))])])]),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }